import { TFunction } from 'i18next';
import { ChampionshipEditTab } from 'modules/championship/domain/enums/championship-edit-tab';
import { Tab } from 'ud-ui/components/tabs/interfaces';

/**
 * Подписи и порядок вкладок формы редактирования соревнования.
 *
 * Функция, а не константа: `t` доступна только во время рендера, и подписи,
 * посчитанные на импорте модуля, не пережили бы смену языка. Hash-и — в
 * `domain/enums/championship-edit-tab.ts`, они часть роута.
 *
 * `isFlow1447` — A/B-флаг `applicationsFlow1447` (ветка IMGM-1447 против продакшена): переименовал
 * три из пяти подписей и убрал стрелку после подписи неактивной вкладки (`showArrow`, ud-ui).
 * I18n-ключи хранят её (новый) вариант подписи, а легаси-текст при выключенном флаге захардкожен
 * здесь же — отдельного i18n-ключа под старую версию заводить не стали, это временная развилка
 * A/B-теста, а не постоянная локализация. Оба вызывающих (`edit-form/tabs.tsx`,
 * `create-form/tabs.tsx`) обязаны передавать актуальное значение флага — экран создания
 * соревнования тоже должен сразу показывать нужный вариант, а не только экран редактирования.
 */
export const getChampionshipEditTabs = (t: TFunction, isFlow1447: boolean): Tab[] => [
  {
    hash: ChampionshipEditTab.COMMON,
    label: isFlow1447 ? t('championship.editTabs.common') : 'Основные данные',
    showArrow: !isFlow1447,
  },
  {
    hash: ChampionshipEditTab.RULES,
    label: isFlow1447 ? t('championship.editTabs.rules') : 'Условия',
    showArrow: !isFlow1447,
  },
  {
    hash: ChampionshipEditTab.TEAMS,
    label: isFlow1447 ? t('championship.editTabs.applications') : 'Заявки',
    showArrow: !isFlow1447,
  },
  { hash: ChampionshipEditTab.STEPS, label: t('championship.editTabs.steps'), showArrow: !isFlow1447 },
  { hash: ChampionshipEditTab.SYMBOLIC_TEAMS, label: t('championship.editTabs.symbolicTeams'), showArrow: !isFlow1447 },
  // Вкладки GAMES, APPLICATIONS и RESULTS были закомментированы до этой задачи.
];
